import { render, staticRenderFns } from "./livecollect.vue?vue&type=template&id=648dfb87&scoped=true"
import script from "./livecollect.vue?vue&type=script&lang=js"
export * from "./livecollect.vue?vue&type=script&lang=js"
import style0 from "./livecollect.vue?vue&type=style&index=0&id=648dfb87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648dfb87",
  null
  
)

export default component.exports